import clsx from 'clsx';
import type { ReactNode } from 'react';

type MenuItemVariant = 'default' | 'muted' | 'danger';

type MenuItemProps = {
  children: ReactNode;
  onClick?: () => void;
  variant?: MenuItemVariant;
  className?: string;
};

const variantClass: Record<MenuItemVariant, string> = {
  default: 'text-black hover:text-blue-700',
  muted: 'text-[#B2B2B2] hover:text-gray-500',
  danger: 'text-red-600 hover:text-red-400',
};

export default function MenuItem({ children, onClick, variant = 'default', className }: MenuItemProps) {
  return (
    <button
      role="menuitem"
      onClick={onClick}
      className={clsx(
        'w-full self-stretch border-0 bg-transparent p-0 text-left text-base font-medium transition-colors duration-200 ease-in-out',
        variantClass[variant],
        onClick ? 'cursor-pointer' : 'cursor-default',
        className
      )}
    >
      {children}
    </button>
  );
}
